import { useState } from 'react'
import { Img } from '@chakra-ui/react'
import LogoIcon from '../../assets/wrk_logo.png'
export interface OrganisationBranding {id:string;name:string;logo?:string|null}
/** Keep tenant artwork uncropped; mismatched or broken artwork uses the product mark. */
export default function OrganisationLogo({branding,organisationId}:{branding?:OrganisationBranding|null;organisationId?:string|null}) {
 const [failed,setFailed]=useState<string|null>(null)
 const tenant=branding?.id===organisationId&&branding.logo&&branding.logo!==failed?branding:null
 return <Img key={tenant?.logo||'aboutwork'} src={tenant?.logo||LogoIcon} alt={tenant?.name||'AboutWork'} maxW="178px" width={tenant?'100%':'100px'} height="58px" objectFit="contain" onError={tenant?.logo?()=>setFailed(tenant.logo!):undefined}/>
}
